<style lang="less">
</style>
<template>
    <span>
        <Drawer title="考试安排" :closable="false" placement="right" v-model="examination" width="60%">
            <Row class="operation">
                <Button @click="add" type="primary" icon="md-add">新增安排</Button>
                <circleLoading v-if="operationLoading"/>
            </Row>
            <Row style="padding-top: 5px">
                <Table :loading="loading" border :columns="columns" :data="data" ref="userTable"></Table>
            </Row>
            <Row type="flex" justify="end" class="page">
                <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
            </Row>
        </Drawer>
        <examination-drawer ref="examinationDrawer"></examination-drawer>
    </span>
</template>

<script>
    import {examinationList} from "@/api/bus";
    import examinationDrawer from "./examination-drawer";
    export default {
        name: "examination-manage",
        components: {
            examinationDrawer,
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                examination: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "applyBeginDate", // 默认排序字段
                    order: "asc", // 默认排序方式
                    courseTitle: "",
                    userName: "",
                    startDate: "",
                    endDate: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [

                    {
                        type: "index",
                        width: 50,
                        align: "center"
                    },
                    {
                        title: "考试时间",
                        align: "center",
                        key: "examTime"
                    },
                    {
                        title: "报名开始时间",
                        align: "center",
                        key: "applyBeginDate"
                    },
                    {
                        title: "报名结束时间",
                        align: "center",
                        key: "applyEndDate"
                    },
                    {
                        title: "缴费结束时间",
                        align: "center",
                        key: "payEndDate"
                    },
                    {
                        title: "退考截止时间",
                        align: "center",
                        key: "quitDate"
                    },
                    {
                        title: "考试安排code值",
                        align: "center",
                        key: "examinationCode"
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            showDrawer(params){
                this.examination = true;
                if (params.id) {
                    this.searchForm.certificateId = params.id;
                    this.getDataList();
                }
            },
            getDataList() {
                this.loading = true;
                examinationList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            edit(v) {
                this.$refs.examinationDrawer.showDrawer(v);
            },
            add() {
                let query = {id: '', certificateId: this.searchForm.certificateId}
                this.$refs.examinationDrawer.showDrawer(query);
            },
            //设置课程推荐状态
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                // 重新加载数据
                this.getDataList();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
        }
    }
</script>
